import { render, staticRenderFns } from "./SectionMenu.vue?vue&type=template&id=41e1bafb&scoped=true"
import script from "./SectionMenu.vue?vue&type=script&lang=js"
export * from "./SectionMenu.vue?vue&type=script&lang=js"
import style0 from "./SectionMenu.vue?vue&type=style&index=0&id=41e1bafb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e1bafb",
  null
  
)

export default component.exports